interface BrowserInfo {
  name: string;
  version: string;
  os: string;
}

function getBrowserInfo(): BrowserInfo {
  const userAgent = navigator.userAgent;

  let name = "Unknown";
  let version = "";
  let os = "Unknown";

  if (userAgent.includes("Firefox/")) {
    name = "firefox";
    version = userAgent.split("Firefox/")[1]?.split(" ")[0] ?? "";
  } else if (userAgent.includes("Edg/")) {
    name = "edge";
    version = userAgent.split("Edg/")[1]?.split(" ")[0] ?? "";
  } else if (userAgent.includes("Chrome/")) {
    name = "chrome";
    version = userAgent.split("Chrome/")[1]?.split(" ")[0] ?? "";
  } else if (userAgent.includes("Safari/") && !userAgent.includes("Chrome")) {
    name = "safari";
    version = userAgent.split("Version/")[1]?.split(" ")[0] ?? "";
  }

  if (userAgent.includes("Windows")) {
    os = "Windows";
  } else if (userAgent.includes("Mac OS")) {
    os = "Mac OS";
  } else if (userAgent.includes("Linux")) {
    os = "Linux";
  } else if (userAgent.includes("Android")) {
    os = "Android";
  } else if (userAgent.includes("iOS") || userAgent.includes("iPhone")) {
    os = "iOS";
  }

  return { name, version, os };
}

export { getBrowserInfo };
export type { BrowserInfo };
